import React, { useState } from "react";
import styled, { css, keyframes } from "styled-components";
import useSound from "use-sound";
import notSelectedSFX from "../../../audio/notSelected.mp3";

import forwardSound from "../../../audio/goForward.mp3";

// import SideOptions from "./SideOptions";

export const FooterStyled = styled.div`
  /* display: flex; */
  /* justify-content: flex-end; */
  /* align-items: center; */
  width: 315px;
  margin: 0 auto;
  overflow: hidden;
`;

export const Balance = styled.div`
  border-radius: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 12px;
  white-space: nowrap;

  box-shadow: inset 0px 0px 0px 3px #ffb000;
  color: #ffb000;
  text-align: center;
  width: 62.223%;
  height: 46px;
  cursor: pointer;
  svg {
    margin-left: 4px;
    height: 11px;
    path {
      fill: #ffb000;
    }
  }
`;
const whiteDivOpa1 = keyframes`
  0%{
    animation-timing-function: cubic-bezier(0,0,.2,1);
    opacity: 0;
     }
  33%{
    animation-timing-function: cubic-bezier(1.5,3.6,.2,1);
     opacity: 0.5;
    }
  100%{
     opacity:0;
  } 
`;
const playUnpressAnim = keyframes`
  0%{
    transform: scale(.8);
    transition-timing-function: cubic-bezier(0,0,.2,.93);
 
   }
  50%{
    transition-timing-function: cubic-bezier(.31,-0.17,.67,1.21);
    transform: scale(1.05);

   }
  100%{
 
    transform: scale(1);
   } 
`;
const playUnPress = css`
  ${playUnpressAnim}
`;
export const PlayBtn = styled.div`
  position: relative;
  background: #ffb000;
  font-size: 20px;
  color: #ff3920;
  font-weight: bold;
  border-radius: 38px;
  width: 48%;
  height: 46px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  animation: ${(p) => (p.playUnpress ? playUnPress : null)};
  animation-duration: 0.2s;
  animation-fill-mode: forwards;
  animation-delay: 1s;
  ${(p) =>
    p.playPress
      ? "transform: scale(0.8);transition-timing-function: cubic-bezier(.29,.16,.29,1.23); transition: transform 0.1s;"
      : "transform: scale(1); transition-timing-function: cubic-bezier(0.1, 0, 0, 1); transition: transform 0.1s;"};

  .white {
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50px;
    background: #ffffff;
    opacity: 0;
    animation: ${(p) => (p.anim ? whiteDivOpa : null)};
  }
  /* @media only screen and (max-width: 374px) {
    font-size: 18px;
    width: 40%;
  } */
`;

const scaleAnim = keyframes`
  0%{
    animation-timing-function: cubic-bezier(.33,1,0,1);
    transform: translateX(264px) scale(1);
    }
  50%{
    animation-timing-function: cubic-bezier(0,0,0,1);
    transform: translateX(264px) scale(.65);

   }
  100%{
    transform: translateX(264px) scale(1); 
    } 
`;
const anim = css`
  ${scaleAnim}
`;

const whiteDivOpa = css`
  ${whiteDivOpa1}
`;
export const SideOptionBtn = styled.div`
  position: relative;
  width: 56px;
  height: 56px;
  background: #ffb000;
  border-radius: 50%;
  color: #ff3920;
  font-size: 20px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  ${(props) =>
    props.mode80 || props.mode40
      ? " width: 46px; height: 46px; font-size: 16px;"
      : " width: 56px; heigt: 56px; font-size: 20px;"}

  transform: ${(p) =>
    p.showOptions ? "translateX(264px)" : "translateX(0px)"};

  transition: ${(p) =>
    `transform 250ms ${p.delay} cubic-bezier(0.35, 0, 0.2, 1)`};

  cursor: pointer;
  animation: ${(p) => (p.anim ? anim : null)};
  animation-duration: 0.33s;
  animation-fill-mode: forwards;
  animation-delay: 1s;
  .white {
    position: absolute;
    left: 1px;
    top: 1px;
    width: 100%;
    height: 100%;
    border-radius: 50px;
    background: #ffffff;
    opacity: 0;

    animation: ${(p) => (p.anim ? whiteDivOpa : null)};
    animation-duration: 0.33s;
    animation-fill-mode: forwards;
    animation-delay: 1s;
  }
  .randomSVG {
    width: 30px;
    height: 30px;
  }
  .randomSonicSVG {
    width: 30px;
    height: 30px;
  }
  .autoSVG {
    width: 30px;
    height: 30px;
  }
  .CleanSVG {
    width: 22px;
    height: 22px;
  }
  /* @media only screen and (max-width: 374px) {
    font-size: 1em;
    width: 46px;
    height: 46px;
    svg {
      width: 26px;
      height: 26px;
    }
    .CleanSVG {
      width: 18px;
      height: 18px;
    }
    .randomSonicSVG {
      width: 26px;
      height: 26px;
    }
  } */
`;

const scaleAnimFooterBtn = keyframes`
  0%{  
    animation-timing-function: cubic-bezier(.33,1,0,1);
    transform: scale(1);
    }
  50%{
    animation-timing-function: cubic-bezier(0,0,0,1);
    transform: scale(.65);

   }
  100%{
    transform: scale(1); 
    } 
`;
const animFooterBtn = css`
  ${scaleAnimFooterBtn}
`;
export const FooterBtn = styled.div`
  position: relative;
  width: 56px;
  height: 56px;
  background: #ffb000;
  border-radius: 50%;
  color: #ff3920;
  font-size: 20px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  ${(props) =>
    props.mode80 || props.mode40
      ? " width: 46px; height: 46px; font-size: 16px;"
      : " width: 56px; heigt: 56px; font-size: 20px;"}

  transform: ${(p) =>
    p.showOptions ? "translateX(264px)" : "translateX(0px)"};

  transition: ${(p) =>
    `transform 250ms ${p.delay} cubic-bezier(0.35, 0, 0.2, 1)`};

  cursor: pointer;
  animation: ${(p) => (p.anim ? animFooterBtn : null)};
  .white {
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50px;
    background: #ffffff;
    opacity: 0;

    animation: ${(p) => (p.anim ? whiteDivOpa : null)};
    animation-duration: 0.33s;
    animation-fill-mode: forwards;
    animation-delay: 1s;
  }
  .randomSVG {
    width: 30px;
    height: 30px;
  }
  .randomSonicSVG {
    width: 30px;
    height: 30px;
  }
  .autoSVG {
    width: 30px;
    height: 30px;
    margin-left: 8px;
  }
  .CleanSVG {
    width: 22px;
    height: 22px;
  }
  /* @media only screen and (max-width: 374px) {
    font-size: 1em;
    width: 46px;
    height: 46px;
    svg {
      width: 26px;
      height: 26px;
    }
    .CleanSVG {
      width: 18px;
      height: 18px;
    }
    .randomSonicSVG {
      width: 26px;
      height: 26px;
    }
  } */
`;
export const SideOptionBox = styled.div`
  /* position: absolute; */
  display: flex;
  align-items: center;
  justify-content: center;
  background: #7f3da5;
  width: 280px;

  div {
    margin-right: 10px;
    box-shadow: 0 14px 10px 0 rgba(50, 7, 91, 0.5);
  }
`;
export const BackOptionBtn = styled.div`
  height: 56px;
  width: 60px;
  background: #ffb000;
  border-top-left-radius: 38px;
  border-bottom-left-radius: 38px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 0 0 17px;

  /* @media only screen and (max-width: 374px) {
    height: 46px;
  } */
`;
export const Space = styled.div`
  height: 15px;
  width: 100%;
  max-width: 320px;
  /* @media only screen and (max-width: 374px) {
    height: 5px;
  } */
`;

export const MainOptions = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 300px;
  /* scale: 0.65; */
  z-index: -1;
  transform: ${(p) =>
    p.showOptions ? "translateX(240px)" : "translateX(0px)"};
  transition: ${(p) =>
    `transform 250ms ${p.delay} cubic-bezier(0.17, 0.17, 0.2, 1)`};
`;

export const FooterSonic = styled.div`
  display: flex;
  padding: 0 0 25px 0;
  /* box-sizing: border-box; */
  justify-content: center;
  align-items: center;
  width: 576px;
  height: 107px;
  /* max-width: 192%; */
  margin: auto;
  /* -webkit-transform: translateX(-46%); */
  transform: translateX(-265px);
  pointer-events: ${(p) => (p.clickable ? "auto" : "none")};
  /* transform: ${(p) => (p.isSafari ? "translateX(-139px)" : "translateX(-46%)")}; */
  /* transform: translateX(calc(-576px + 50%)); */
`;

export function LeftArrow({ click, showOptions }) {
  return (
    <div
      onClick={click}
      style={{
        cursor: "pointer",
        pointerEvents: showOptions ? "none" : "auto",
        opacity: showOptions ? "0" : "1",
        transition: " opacity 100ms ",
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="11"
        height="25"
        viewBox="0 0 11 25"
      >
        <path
          fill="none"
          fillRule="evenodd"
          stroke="#32075B"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3"
          d="M2 2l7 10.5L2 23"
        />
      </svg>
    </div>
  );
}
const rightArrowScale = keyframes`
  0%{
    animation-timing-function: cubic-bezier(0.17, -0.12, 0.67, 1);
    transform: scale(1);
    opacity: 1;
    }
  50%{
    animation-timing-function: cubic-bezier(0.33, 0, 0.67, 1);
    transform: scale(.85);
    opacity: .5;
   }
  100%{
    transform: scale(1); 
    opacity: 1;
    } 
`;
const rightArrowScaleAnim = css`
  ${rightArrowScale}
`;
const RightArrowD = styled.div`
  cursor: pointer;
  animation: ${(p) => (p.anim ? rightArrowScaleAnim : null)};
  animation-duration: 0.33s;
  animation-fill-mode: forwards;
  animation-delay: 1s;
`;

export function RightArrow({ click, n, handleNotification, sound, volume }) {
  const [forwardSFX] = useSound(forwardSound, { volume });

  const [anim, setanim] = useState(false);
  const [playnotSelectedSFX] = useSound(notSelectedSFX, { volume });
  return (
    <RightArrowD
      onClick={() => {
        if (n > 0) {
          if (sound) forwardSFX();
          setanim(true);

          setTimeout(() => {
            setanim(false);
            click();
          }, 400);
        } else {
          handleNotification("Choose at least 1 ball");
          if (sound) playnotSelectedSFX();
        }
      }}
      anim={anim}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="25"
        viewBox="0 0 18 25"
      >
        <g
          fill="none"
          fillRule="evenodd"
          stroke="#32075B"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3"
        >
          <path d="M9 2l7 10.5L9 23M2 2l7 10.5L2 23" />
        </g>
      </svg>
    </RightArrowD>
  );
}
export const FooterBox = styled.div`
  display: flex;
  align-items: center;
  margin: 0 auto;
  justify-content: space-between;
  max-width: 320px;
  width: 100%;
`;
